<!-- @format -->

<info-invoice-provider-tag>

    <div class="container_contents">

        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="/info" class="information">会員情報</a></li>
                <li class="breadcrumb-item"><h1>登録情報の変更</h1></li>
            </ul>
        </div>

        <div class="contents">
            <section class="contents_area">
                <div class="contents_block">
                    <p class="important_message important_message02 margin-spacing-4_bottom">
                        適格請求書発行事業者についての情報更新</p>

                    <div is="invoice-provider-are"></div>
                </div>
            </section>
        </div>

    </div>
    <script>
        import invoiceProviderForm from "@tags/parts/info/invoice-provider/form.riot";
        import invoiceProvider from "@model/invoiceProvider/api";

        export default {

            components: {
                'invoice-provider-are': invoiceProviderForm
            },
            invoiceProvider: invoiceProvider,
            listenerUpdate() {
                this.update()
            },
            onMounted(props, state) {
                this.invoiceProvider.on('update', this.listenerUpdate)
            },
            onUnmounted(props, state) {
                this.invoiceProvider.off('update', this.listenerUpdate)
            }
        }
    </script>
</info-invoice-provider-tag>